export default __webpack_public_path__ + "static/media/tron.513a0221.gif";